import EnhancedProductTemplate from "./enhanced-product-template";
import { Database, BarChart3, Cpu, GitBranch, Monitor } from "lucide-react";
import { useTranslation } from "../../../i18n";
import twins from "./../assets/twins.png";
export default function DigitalTwinsSection() {
  const { t } = useTranslation();
  const features = [
    {
      title: t("routes.digitalTwins.section.features.registryTitle"),
      description: t("routes.digitalTwins.section.features.registryDesc"),
      icon: <Database className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.digitalTwins.section.features.automationTitle"),
      description: t("routes.digitalTwins.section.features.automationDesc"),
      icon: <GitBranch className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.digitalTwins.section.features.uiLayoutsTitle"),
      description: t("routes.digitalTwins.section.features.uiLayoutsDesc"),
      icon: <Monitor className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.digitalTwins.section.features.parameterTitle"),
      description: t("routes.digitalTwins.section.features.parameterDesc"),
      icon: <BarChart3 className="h-4 w-4 text-white" />,
    },
    {
      title: t("routes.digitalTwins.section.features.edgeExecutionTitle"),
      description: t("routes.digitalTwins.section.features.edgeExecutionDesc"),
      icon: <Cpu className="h-4 w-4 text-white" />,
    },
  ];

  const stats = [
    { label: t("routes.digitalTwins.section.stats.deviceTypes"), value: "50+" },
    {
      label: t("routes.digitalTwins.section.stats.parametersTracked"),
      value: "1M+",
    },
    {
      label: t("routes.digitalTwins.section.stats.automationRules"),
      value: "1K+",
    },
  ];

  return (
    <EnhancedProductTemplate
      logoSrc={null}
      logoAlt={t("routes.digitalTwins.section.logoAlt")}
      title={t("routes.digitalTwins.section.title")}
      slogan={t("routes.digitalTwins.section.slogan")}
      description={t("routes.digitalTwins.section.description")}
      features={features}
      imageSrc={twins}
      imageAlt={t("routes.digitalTwins.section.imageAlt")}
      primaryCtaText={t("routes.digitalTwins.section.primaryCta")}
      primaryCtaLink="https://docs.juhuu.app/articles/art_686ea5d89caa5236fbdcbafc"
      secondaryCtaText={t("routes.digitalTwins.section.secondaryCta")}
      secondaryCtaLink="https://docs.juhuu.app/articles/art_686ea5d89caa5236fbdcbafc"
      colorScheme="purple"
      layout="default"
      showBadge={true}
      badgeText={t("routes.digitalTwins.section.badge")}
      showStats={true}
      stats={stats}
      showTestimonial={true}
      showAnimation={true}
    />
  );
}
